import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddToCallListModal from 'components/modals/add_to_call_list_modal';

import { stopAddToCallList } from '../../store/actions/call_lists';
import { createBulkTask } from '../../store/actions/companies';

import { getTargetContactIds, getTargetList, isAddingContactsToList } from '../../store/selectors/call_lists';
import { getDatabaseMembers } from '../../store/selectors/companies';
import { getCompaniesById } from '../../store/selectors/search';
import { getAvailableDatabases, getCurrentUser } from '../../store/selectors/static';

export class CompaniesAddToCallListModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callList: PropTypes.object,
    companies: PropTypes.objectOf(PropTypes.shape({
      id: PropTypes.number.isRequired
    })).isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    selectedCompanyIds: PropTypes.array.isRequired,
    showModal: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  };

  handleAddToCallList = (data) => {
    const { selectedCompanyIds, onAdd, onCancel } = this.props;
    const ids = [];
    selectedCompanyIds.forEach(id => ids.push([id, "Contacts::Company"]));
    onAdd(data, ids);
    onCancel();
  }

  render() {
    const {
      availableDatabases,
      callList,
      currentUser,
      selectedCompanyIds,
      showModal,
      databaseMembers,
      onCancel
    } = this.props;

    const selectedContacts = [];
    selectedCompanyIds.forEach((id) => {
      const company = this.props.companies[id] || { id: id, unloaded: true };
      selectedContacts.push(company);
    });

    return (
      <AddToCallListModal
        availableDatabases={availableDatabases}
        callList={callList}
        currentUser={currentUser}
        databaseMembers={databaseMembers}
        defaultAssociatedModels={this.getDefaultAssociatedModels()}
        selectedContacts={selectedContacts}
        shown={showModal}
        onCancel={onCancel}
        onSubmit={this.handleAddToCallList}
      />
    );
  }

  getDefaultAssociatedModels() {
    return [
      {
        associatedModelId: 1,
        associatedModelType: "Multiple",
        name: "Multiple Contacts",
        default: true
      }
    ];
  }
}

const mapStateToProps = state => ({
  availableDatabases: getAvailableDatabases(state),
  callList: getTargetList(state),
  currentUser: getCurrentUser(state),
  databaseMembers: getDatabaseMembers(state),
  companies: getCompaniesById(state),
  selectedCompanyIds: getTargetContactIds(state),
  showModal: isAddingContactsToList(state)
});

const mapDispatchToProps = {
  onAdd: createBulkTask,
  onCancel: stopAddToCallList,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesAddToCallListModal);
